module.exports = __webpack_public_path__ + "img/oracle-procurement-cloud.7ab809c9.png";